import { render, staticRenderFns } from "./main.vue?vue&type=template&id=8d27ce2e&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style1 from "./main.vue?vue&type=style&index=1&id=8d27ce2e&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d27ce2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d27ce2e')) {
      api.createRecord('8d27ce2e', component.options)
    } else {
      api.reload('8d27ce2e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=8d27ce2e&scoped=true", function () {
      api.rerender('8d27ce2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/components/setting-basic/main.vue"
export default component.exports